import { render, staticRenderFns } from "./business-payment.vue?vue&type=template&id=45db1a28&scoped=true&"
import script from "./business-payment.vue?vue&type=script&lang=js&"
export * from "./business-payment.vue?vue&type=script&lang=js&"
import style0 from "./business-payment.vue?vue&type=style&index=0&id=45db1a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db1a28",
  null
  
)

export default component.exports